// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Analysis Extraction node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { AnalysisPromptAdminView } from '../shared/components/AdminView'
import { AnalysisPromptWorkflowNode } from '../shared/components/WorkflowNode'

registerPipelineNode({
  id: 'analysis.analysis_extraction',
  manifest: {
    id: 'analysis.analysis_extraction',
    name: 'Extraction Analysis',
    category: 'analysis',
    icon: 'SearchCheck',
    description: 'Process KB patterns to extract findings or generate report sections',
    order: 30,
  },
  WorkflowNode: AnalysisPromptWorkflowNode,
  AdminConfig: AnalysisPromptAdminView,
})